<!------------------------------------------------------------------------------
 File: SearchUser 
 Created by keni.
 with: IntelliJ IDEA
 Date: 09/04/2018
 Time: 14:42
------------------------------------------------------------------------------->
<template>
    <div class=" ">


        <!--standard layout-->
        <div v-if="search_add_user == false">
            <div class=" d-flex justify-content-between align-items-center ">
                <h2 class="h2-responsive">
                    <span class="btn-primary btn-floating mr-2"
                                               v-on:click="search_add_user = true">
                    <i class="material-icons">add</i>
                </span>
                    <strong>{{role_description}} Users</strong></h2>

            </div>

            <table-search
                    :laravel_route_uri='table_laravel_route_uri'
                    :request_route_url='table_request_route_url'
                    :crud='table_crud'
                    :reload="table_reload"
                    emit_table_event_key_prop="emit_table_event"
                    @emit_table_event="tableActionEventHandler"
            >
            </table-search>
        </div>
        <!--// role user crud-->
        <div v-else>
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class=" d-flex justify-content-start d-flex align-items-center ">
                        <div v-if="selected_users.length > 0"
                             v-on:click="addUsersSubmit()"
                             class="btn btn-primary">
                            Save
                        </div>
                        <div v-if="selected_users.length > 0"
                             v-on:click="init()"
                             class="btn btn-primary">
                            cancel
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8" v-if="selected_users.length <= 0">
                    <search-bar @search_event="searchEvent"
                                @close_search_event="closeSearch()"
                                close_search_action="close_search_action"
                                open_on_load="true"
                    ></search-bar>
                </div>
            </div>


            <div class="table-responsive">
                <transition name="fade">
                    <table v-if="!isEmpty(users)" class="table w-auto table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>First</th>
                            <th>Last</th>
                            <th>Email</th>
                            <th>Roles</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in users" :class="{
                        'table-primary':userInSelected(user),
                        'cursor-pointer':userInSelected(user),
                        'cursor-copy':!userInSelected(user),
                        }"
                            v-on:click="toggleUserToListSubmissionList(user)"
                        >
                            <td>{{user.first_name}}</td>
                            <td>{{user.last_name}}</td>
                            <td>{{user.email}}</td>
                            <td>
                            <span v-for="role in user.roles" :class="{
                                'badge badge-primary':parseInt(role.id) === parseInt(role_id)
                            }">
                               {{role.name}}
                            </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </transition>
            </div>

        </div>
    </div>

</template>

<script>
    import {_} from 'underscore';

    Vue.component('table-search', require('../../tables/tableSearch'));
    Vue.component('search-bar', require('../../../../../../app/Shared/Resources/Assets/js/components/SearchBar'));

    export default {
        name: "",
        components: {},
        props: {
            current_user_id: Number,
            table_laravel_route_uri: String,
            table_request_route_url: String,
            table_crud: Object,
            search_user_uri: String,
            role_id: String,
            role_description: String,
            add_user_to_role_uri: String,
            delete_user_to_role_uri: String,
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            console.log('this.current_user_id', this.current_user_id);
        },
        data() {
            return {
                table_reload: false,
                user: '',
                users: [],
                selected_users: [],
                search_add_user: false,
                search_val: null,
                inputLengthBeforeSubmit:5,
                inputDebounceTime:600
            }
        },
        methods: {
            tableActionEventHandler(obj) {
                if (obj.action == 'delete') {
                    this.removeUserSubmit(obj.id);
                }
                else if (obj.action == 'table_reloaded') {
                    this.table_reload = false;
                }
            },
            debug() {
                if (typeof(console) !== 'undefined') {
                    console.log.apply(console, arguments);
                }
            },
            isEmpty(obj) {
                return _.isEmpty(obj);
            },
            init() {
                this.users = [];
                this.selected_users = [];
                this.search_add_user = false;
                this.search_val = null;
            },
            toggleUserToListSubmissionList(user) {
                if (!this.userInSelected(user)) {
                    this.selected_users.push(user);
                } else {
                    this.removeUserFromSubmissionList(user);
                }
            },
            userInSelected(user) {
                let _this = this,
                    currentUser = user,
                    test = _.filter(_this.selected_users, function (userTest) {
                        if (currentUser.id == userTest.id) {
                            return true;
                        }
                    });

                return (!_.isEmpty(test));
            },
            removeUserFromSubmissionList(user) {
                let index = this.selected_users.indexOf(user);

                this.selected_users.splice(index, 1)
            },
            closeSearch() {
                this.init();
            },
            searchEvent: _.debounce(function (val) {
                let inputValue = val.trim();
console.log('inputValue',inputValue);
                this.users = [];

                if (inputValue.length > this.inputLengthBeforeSubmit) {
                    this.search_val = inputValue;
                    this.find(inputValue);
                }
            }, this.inputDebounceTime),
            removeUserSubmit(user_id) {
                if (user_id == parseInt(this.current_user_id)) {
                    return;
                }
                // loop users
                let _this = this,
                    data = {
                        user_id: user_id,
                        role_id: parseInt(this.role_id)
                    };

                axios.post(this.delete_user_to_role_uri, data)
                    .then(function (response) {
                        if (response.data.success) {
                            _this.table_reload = true;
                            _this.init();
                        }
                    })
                    .catch(function () {

                    });
            },
            addUsersSubmit() {
                let
                    _this = this,
                    data = {
                        user_id: this.selected_users,
                        role_id: parseInt(this.role_id)
                    };

                axios.post(this.add_user_to_role_uri, data)
                    .then(function (response) {
                        // console.log('response.data.success', response.data.success);
                        if (response.data.success === true) {
                            _this.init();
                        }
                    })
                    .catch(function () {

                    });
                // console.log('this',this);
                // this.find(this.search_val);

            },
            find(val) {
                let data = {
                    input: val
                }, _this = this;
                _this.search_add_user = true;
// console.log('val',val);
                axios.post(this.search_user_uri, data)
                    .then(function (response) {
                        // console.log('response.data', response.data);
                        if (response.data.success) {
                            _this.users = response.data.result;
                        }
                    })
                    .catch(function (e) {
                        console.error('e', e);
                    });
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/search/SearchUserRoleCrud.vue?62657f5d